/**
 * 管理側インフォメーションパネルのカラーセット
 */
export namespace InformationPanelColorSet {
  /**
   * 先生権限
   */
  export const TEACHER: ColorSet = {
    background: '--color-information-panel__teacher__background',
    button: '--color-information-panel__teacher__button',
    text: '--color-information-panel__teacher__text',
  }

  /**
   * 塾権限
   */
  export const ACADEMY: ColorSet = {
    background: '--color-information-panel__academy__background',
    button: '--color-information-panel__academy__button',
    text: '--color-information-panel__academy__text',
  }

  /**
   * システム管理者権限
   */
  export const ADMIN: ColorSet = {
    background: '--color-information-panel__admin__background',
    button: '--color-information-panel__admin__button',
    text: '--color-information-panel__admin__text',
  }

  /**
   * カラーセットの型
   */
  export type ColorSet = {
    /** 背景色 */
    background: string
    /** ボタン色 */
    button: string
    /** 文字色 */
    text: string
  }
}
